import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import { HttpUtil } from "../../Utils/http-utils";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import {
  getToken,
  GET_INFRASTRUCTURE_DETAILS,
  GET_TIME_SLOT,
  GET_WORKING_HOURS_SLOT,
  getTempararyTokenProviderAssist,
  getCampaignsToken,
} from "../../Utils/types";
import ROUTES from "../../Utils/routesConstants";

export const getInfrastructureDetailsAction = () => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/GetInfrastructureDetails/${getCampaignsToken()}`
  : `${API_URL_WITHOUT_USER}/InfrastructureDetails/GetInfrastructureDetails`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
        ? getTempararyTokenProviderAssist() :  window.location.pathname.includes("campaigns") ? null 
        : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_INFRASTRUCTURE_DETAILS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_INFRASTRUCTURE_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const updateInfrastructureDetailsAction = (data) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/AddUpdateInfrastructureDetails/${getCampaignsToken()}`
  : `${API_URL_WITHOUT_USER}/InfrastructureDetails/AddUpdateInfrastructureDetails`;
  return HttpUtil.makePOST(url, data, {
    Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist() :  window.location.pathname.includes("campaigns") ? null 
      : getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", "Details updated successfully", dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const getTimeSlotAction = (startTime, endTime) => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/GetTimeSlot/${getCampaignsToken()}?startTime=${startTime}&EndTime=${endTime}`
  : `${API_URL_WITHOUT_USER}/InfrastructureDetails/GetTimeSlot?startTime=${startTime}&EndTime=${endTime}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
        ? getTempararyTokenProviderAssist() :  window.location.pathname.includes("campaigns") ? null 
        : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_TIME_SLOT, res?.data?.results?.timeSlot, dispatch);
    } else {
      getDispatch(GET_TIME_SLOT, [], dispatch);
    }
  });
};

export const getWorkingHoursSlotAction = (startTime, endTime) => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/GetTimeSlot/${getCampaignsToken()}?startTime=${startTime}&EndTime=${endTime}`
  : `${API_URL_WITHOUT_USER}/InfrastructureDetails/GetTimeSlot?startTime=${startTime}&EndTime=${endTime}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
        ? getTempararyTokenProviderAssist() :  window.location.pathname.includes("campaigns") ? null 
        : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_WORKING_HOURS_SLOT,
        res?.data?.results?.timeSlot,
        dispatch
      );
    } else {
      getDispatch(GET_WORKING_HOURS_SLOT, [], dispatch);
    }
  });
};
